import { FaInstagram, FaTwitter } from "react-icons/fa";

import {
	Flex,
	Stack,
	Modal,
	Heading,
	ModalBody,
	ModalOverlay,
	ModalContent,
	Center,
	Divider,
} from "@chakra-ui/react";

import { SocialButton } from "../components/SocialButton";
import { LinkButton } from "../components/LinkButton";

interface LinksProps {
	isOpen: boolean;
	onClose: () => void;
}

export const LinksModal = ({ isOpen, onClose }: LinksProps) => {
	return (
		<Modal size="full" isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalBody>
					<Center h="100vh">
						<Stack align="center" w="fit-content">
							<Heading textAlign="center" pb="2">
								LULU
							</Heading>

							<Divider borderColor="brand.contrast" />

							<LinkButton label="meet me" onClick={onClose} />

							<Stack align="center" gap="0">
								<LinkButton
									label="onlyfans"
									link="https://www.onlyfans.com/lulureynoldsx"
								/>
								<LinkButton
									label="manyvids"
									link="https://www.manyvids.com/Profile/537557/LuluReynolds/Store/Videos/"
								/>
							</Stack>
							<Flex w="100%" gap="3" justify="center">
								<SocialButton
									label="instagram"
									icon={FaInstagram}
									link="https://www.instagram.com/thetitfairy"
								/>
								<SocialButton
									label="twitter"
									icon={FaTwitter}
									link="https://www.twitter.com/lulureynoldsx"
								/>
							</Flex>
						</Stack>
					</Center>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};
